import { MdOutlineDeliveryDining } from "react-icons/md";
import { TbBowlChopsticks, TbCalendarMonth, TbClockBolt, TbDeviceMobileCheck, TbShoppingBag } from "react-icons/tb";

export const ORDER_TYPE_DELIVERY_ID = 1;
export const ORDER_TYPE_TAKE_AWAY_ID = 2;
export const ORDER_TYPE_DINE_IN_ID = 3;
export const ORDER_TYPE_SCHEDULING_ID = 4;
export const ORDER_TYPE_STORE_COUNTER_ID = 5;
export const ORDER_TYPE_DIRECT_SALE_ID = 5;

export const ORDER_TYPE_DELIVERY = 'delivery';
export const ORDER_TYPE_TAKE_AWAY = 'take_away';
export const ORDER_TYPE_DINE_IN = 'dine_in';
export const ORDER_TYPE_SCHEDULING = 'scheduling';
export const ORDER_TYPE_STORE_COUNTER = 'store_counter';
export const ORDER_TYPE_DIRECT_SALE = 'direct_sale';

export const LABEL_DELIVERY = 'Delivery';
export const LABEL_TAKE_AWAY = 'Buscar na loja';
export const LABEL_DINE_IN = 'Comer na loja';
export const LABEL_SCHEDULING = 'Encomenda';
export const LABEL_STORE_COUNTER = 'Comanda';
export const LABEL_DIRECT_SALE = 'Papa fila';

export const ORDER_TYPE_LABELS = {
    'delivery': LABEL_DELIVERY,
    'take_away': LABEL_TAKE_AWAY,
    'dine_in': LABEL_DINE_IN,
    'scheduling': LABEL_SCHEDULING,
    'store_counter': LABEL_STORE_COUNTER,
    'direct_sale': LABEL_DIRECT_SALE
}

export const ORDER_TYPE_ICONS = {
    'delivery': <MdOutlineDeliveryDining />,
    'take_away': <TbShoppingBag />,
    'dine_in': <TbBowlChopsticks />,
    'scheduling': <TbCalendarMonth />,
    'store_counter': <TbDeviceMobileCheck />,
    'direct_sale': <TbClockBolt />
}

